/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupMembersInputDto { 
    groupId: number;
    existingUserId?: number | null;
    memberTypeId: number;
    countryCode?: string | null;
    phoneNumber?: string | null;
    fullName?: string | null;
    emailAddress?: string | null;
    readonly surname?: string | null;
    readonly middleName?: string | null;
    readonly name?: string | null;
}

